import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { CampaignDetailResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof CampaignDetailResponseDataSchema>>

export const getCampaignQueryKey = (id: string) => ["campaigns", id]

type Options = {
  enabled?: boolean
  onSuccess?: (data: z.infer<typeof CampaignDetailResponseDataSchema>) => void
}

export const campaignQuery = (id: string, options: Options = {}) => {
  return queryOptions({
    queryKey: getCampaignQueryKey(id),
    queryFn: async () => {
      const response = await axios.get<Response>(`/campaigns/${id}`)

      options.onSuccess?.(response.data.data)

      return response.data.data
    },
    enabled: options.enabled,
    staleTime: 1000 * 60 * 2,
  })
}
